/***************************************************************************************
 * @module       Unauthorized Route Utils 
 * @name         techus-Unauthorized Route Utils
 * @description  Component for handling unauthorized route access and redirection
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 ***************************************************************************************/

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const UnAuthRoute = ({ children }) => {
  const { user, token, status } = useSelector((state) => state.auth);
  
  // if (status === 'loading') {
  //   return <div>Loading...</div>;
  // }

  if (localStorage.getItem('user_access_token')) {
    
    return <Navigate to="/projects" />;
  }
  // if ( localStorage.getItem('user_access_token')) {
  //   return <Navigate to="/login" />;
  // }

  // if (!roles.includes('user')) {
  //   return <Navigate to="/" />;
  // }

  return <>{children}</>;
};

export default UnAuthRoute;
